var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      { staticClass: "hero-button", on: { click: _vm.openCalendly } },
      [
        _vm._v(
          " " + _vm._s(_vm.signedIn ? "Contact Us" : "Schedule a Demo") + " "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }